import { render, staticRenderFns } from "./SuggestedForYou.vue?vue&type=template&id=40f60346"
import script from "./SuggestedForYou.vue?vue&type=script&lang=js"
export * from "./SuggestedForYou.vue?vue&type=script&lang=js"
import style0 from "./SuggestedForYou.vue?vue&type=style&index=0&id=40f60346&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAvatar,VDataTable,VIcon,VSpacer,VSwitch})
